const skills = {
  loadFailed: "Não foi possível carregar o catálogo de skills.",
  emptyCatalog: "Nenhuma skill disponível ainda. Quando houver skills publicadas no catálogo, elas aparecem aqui para instalar.",
  noWorkspace: "Selecione um workspace para ver as skills.",
  installed: {
    label: "Instalada",
    title: "Skill instalada",
    description: {
      organization:
        "{{skill}} foi instalada para toda a organização, na versão {{version}}.",
      product: "{{skill}} foi instalada neste workspace, na versão {{version}}.",
      user: "{{skill}} foi instalada só para você, na versão {{version}}.",
    },
  },
  install: "Instalar",
  installer: {
    eyebrow: "Instalar Skill",
  },
  uninstall: "Desinstalar",
  details: "Detalhes",
  close: "Fechar",
  confirmInstall: "Instalar neste workspace",
  version: "Versão {{version}}",
  publisher: {
    platform: "Prodgy",
    organization: "Da organização",
  },
  commands: {
    badge: "{{count}} comando",
    badge_other: "{{count}} comandos",
    title: "Comandos",
    hint: "Pontos de entrada da skill — permitem começar o procedimento por qualquer etapa.",
  },
  steps: {
    overview: "Apresentação",
    license: "Licença",
    files: "Conteúdo",
    integrations: "Ferramentas",
    parameters: "Parâmetros",
    review: "Conclusão",
    back: "Voltar",
    next: "Avançar",
  },
  scripts: {
    runsInProdgy:
      "Traz scripts — rodam no agente do Prodgy. Em agentes externos, dependem de o próprio agente executar código.",
  },
  license: {
    undeclared: "Licença não declarada pelo autor.",
    hint: "Instalar um procedimento de terceiro no workspace é aceitar os termos de quem o escreveu.",
  },
  files: {
    binary: "Arquivo binário — o conteúdo não é exibido aqui.",
    loadFailed: "Não foi possível ler este arquivo.",
  },
  review: {
    version: "Versão {{version}} — é ela que fica fixada nesta instalação.",
    hint: "Publicar uma versão nova no catálogo não altera o que este workspace já usa.",
  },
  detailFailed: "Não foi possível ler o conteúdo desta skill.",
  classifications: {
    project: "gerenciador de projetos",
    versioning: "controle de versão",
    communicator: "comunicador",
    crm: "CRM",
    docs: "documentação",
    llm: "modelo de IA",
    mail: "e-mail",
    storage: "armazenamento",
    other: "outra",
  },
  platform: {
    title: "Recursos do Prodgy que esta skill usa",
    hint: "Não precisam ser configurados e não impedem a instalação — estão aqui para você saber o que a skill vai acessar.",
    emptyGeneric: "Este recurso ainda não tem conteúdo neste workspace.",
    tool: {
      knowledge_search: "Brain",
    },
    empty: {
      knowledge_search:
        "Este workspace não tem Brain ativo. A skill vai funcionar, mas não encontrará o contexto da empresa.",
    },
  },
  integrations: {
    anyOfClass: "qualquer {{classification}}",
    or: " ou ",
    title: "Ferramentas necessárias",
    hint: "Escolha qual ferramenta configurada atende cada uma. Todas precisam ser escolhidas para instalar.",
    none: "Esta skill não depende de nenhuma ferramenta.",
    choose: "Escolha uma ferramenta",
    // Requisito que nomeia uma CATEGORIA aceita várias integrações; o que nomeia
    // um template aceita uma. A dica diz qual dos dois é, para ninguém descobrir
    // clicando (AB#85634, AC15).
    pickMany: "Escolha uma ou mais",
    pickOne: "Escolha uma",
    unavailable: "nenhuma configurada",
    configureFirst: "configure a ferramenta primeiro",
    unavailableExplainer:
      "Esta organização não tem ferramenta configurada para: {{integrations}}. Configure no menu Tools e volte aqui para instalar a skill.",
    pending: "Falta escolher {{count}} ferramenta",
    pending_other: "Faltam escolher {{count}} ferramentas",
    badge: "{{count}} ferramenta necessária",
    badge_other: "{{count}} ferramentas necessárias",
    hintShort: "Ferramentas necessárias: {{integrations}}",
  },
  uninstalled: {
    title: "Skill desinstalada",
    description: "{{skill}} deixou de ser servida aqui. O registro foi preservado e ela pode ser instalada de novo.",
  },
  publish: {
    action: "Importar skill",
    registerTitle: "Importar uma skill",
    registerOnly: "Publicar",
    registerAndInstall: "Publicar e instalar",
    orgInstalledTitle: "Skill no ar e instalada",
    orgInstalledDescription:
      "{{skill}} está na loja da organização e instalada. Todo agente daqui passa a recebê-la.",
    orgNotInstalledTitle: "Skill no ar, mas não instalada",
    orgNotInstalledDescription:
      "{{skill}} está na loja da organização, mas não foi instalada: ela declara ferramentas sem uma candidata óbvia ({{missing}}). Instalar exige uma escolha que só uma pessoa pode fazer.",
    orgPublishedTitle: "Skill no ar",
    orgPublishedDescription:
      "{{skill}} está no catálogo e pode ser instalada. Estar no ar não é estar servindo: instalar é o que põe o procedimento na frente de um agente.",
    personalRegisteredTitle: "Skill criada",
    personalRegisteredDescription: "{{skill}} está no seu espaço e já instalada. Ninguém mais a recebe.",
    personalNotInstalledTitle: "Skill criada, mas não instalada",
    personalNotInstalledDescription:
      "{{skill}} declara ferramentas que não estão disponíveis aqui: {{missing}}. Ela existe no seu espaço, e nada a está servindo ainda.",
    newVersion: "Nova versão",
    onAir: "No ar",
    notPublished: "Não publicada",
    offAir: "Fora do ar",
    pending_one: "{{count}} não publicada",
    pending_other: "{{count}} não publicadas",
    pendingHint_one:
      "Há {{count}} versão registrada acima da que está no ar. Ninguém a recebe até ser publicada.",
    pendingHint_other:
      "Há {{count}} versões registradas acima da que está no ar. Ninguém as recebe até serem publicadas.",
    confirmTitle: "Publicar a versão {{version}}?",
    confirmBody:
      "Ela passa a ser a versão que a loja oferece e, no mesmo ato, quem já tem a skill instalada é levado para ela.",
    confirmRollback:
      "Esta versão é anterior à {{current}}, que está no ar — publicá-la devolve o catálogo ao conteúdo dela.",
    confirmInstalls_one:
      "{{count}} instalação passa a usar esta versão. Fica para trás apenas a que precisar de resposta humana — uma ferramenta nova a escolher, um parâmetro obrigatório sem valor.",
    confirmInstalls_other:
      "{{count}} instalações passam a usar esta versão. Ficam para trás apenas as que precisarem de resposta humana — uma ferramenta nova a escolher, um parâmetro obrigatório sem valor.",
    confirmNoInstalls: "Nenhuma instalação existe hoje — a versão fica disponível na loja.",
    carried_one: "{{count}} instalação levada para a versão nova.",
    carried_other: "{{count}} instalações levadas para a versão nova.",
    keptBehind_one:
      "{{count}} ficou na versão anterior: ela precisa de uma resposta que só uma pessoa pode dar.",
    keptBehind_other:
      "{{count}} ficaram na versão anterior: elas precisam de uma resposta que só uma pessoa pode dar.",
    noChangelog: "Esta versão não traz changelog.",
    newVersionTitle: "Nova versão de {{skill}}",
    currentPackage: "Pacote da versão publicada",
    otherSkill:
      "Este pacote é da skill \"{{got}}\", e não de \"{{expected}}\". Uma versão nova tem de ser da mesma skill.",
    register: "Importar",
    registerFailed: "Não foi possível importar a skill.",
    publishVersion: "Publicar esta versão",
    publishLatest: "Publicar",
    publishedTitle: "Versão publicada",
    publishedDescription: "{{skill}} passou a ser servida na versão {{version}}.",
    publishFailed: "Não foi possível publicar a versão.",
    unpublish: "Despublicar",
    unpublishedTitle: "Skill fora do ar",
    unpublishFailed: "Não foi possível despublicar a skill.",
    offAirHint:
      "Foi despublicada: continua no catálogo, e nenhuma organização a recebe.",
    title: "Publicar uma skill",
    description:
      "Solte o pacote da skill. O que ele declara é lido do arquivo; o que o catálogo precisa é perguntado nos passos seguintes.",
    stepReview: "Revisão",
    loading: "Carregando os dados da skill…",
    facetsChoose: "Escolher etiquetas",
    facetsChosen_one: "{{count}} etiqueta",
    facetsChosen_other: "{{count}} etiquetas",
    facetsNoVocabulary:
      "Nenhuma etiqueta cadastrada ainda — crie a primeira abaixo, no formato nome:valor.",
    facetName: "nome",
    facetValue: "valor",
    dropHere: "Solte aqui a pasta da skill ou um .zip",
    dropHint: "A pasta precisa ter o SKILL.md na raiz.",
    chooseFolder: "Escolher pasta",
    chooseZip: "ou escolher um arquivo .zip",
    dropNothing: "Nada foi solto.",
    dropWrongType: "Solte uma pasta ou um arquivo .zip.",
    readFailed: "Não foi possível ler o pacote.",
    replace: "Trocar pacote",
    fileCount_one: "{{count}} arquivo",
    fileCount_other: "{{count}} arquivos",
    invalidPackage: "Este pacote não pode ser publicado como está:",
    name: "Nome",
    author: "Autor",
    authorUndeclared: "Autor não declarado",
    ownerField: "Dono",
    ownerPlaceholder: "Quem responde por esta skill",
    sourceField: "Fonte",
    sourcePlaceholder: "https://github.com/org/repo",
    sourceLink: "Fonte",
    titleField: "Título",
    descriptionField: "Descrição",
    catalogData: "O que o catálogo precisa",
    scope: "Escopo",
    scopePlaceholder: "Escolha o nível",
    facets: "Etiquetas",
    changelog: "O que mudou nesta versão",
    changelogFor: "O que mudou na versão {{version}}",
    changelogPlaceholder: "Aparece para quem está decidindo se atualiza.",
    core: "Skill core",
    coreHint:
      "Vale para todas as organizações, sem instalação e sem possibilidade de recusa. Use para o procedimento que a casa exige de todo mundo.",
    integrationsHint:
      "O que a skill EXIGE para funcionar. A maior parte das skills não exige nada — declare apenas o procedimento genuinamente preso a uma ferramenta. Vazio, a etapa some da instalação.",
    integrationsEmpty: "Nenhuma ferramenta exigida.",
    requirementId: "Nome do requisito",
    requirementAnyOf: "Atendido por",
    requirementAnyOfPlaceholder: "Escolha as ferramentas que servem",
    requirementAnyOfHint:
      "Mais de uma significa \"qualquer uma destas\". Prefira a família (qualquer gerenciador de projetos) ao produto: quem escreve a skill não sabe qual ferramenta a empresa de destino usa.",
    requirementReason: "Para que serve",
    requirementReasonPlaceholder: "Aparece para quem está escolhendo a ferramenta na instalação.",
    addRequirement: "Adicionar requisito",
    anyOfFamily: "Qualquer {{family}}",
    parametersHint:
      "O que a instalação pergunta, e a resposta fica gravada nela. Vazio, a etapa some da instalação.",
    parametersEmpty: "Nenhum parâmetro.",
    parameterKey: "Chave",
    parameterLabel: "Rótulo",
    parameterLabelPlaceholder: "Como o campo aparece na instalação",
    parameterType: "Tipo",
    parameterDefault: "Valor padrão",
    parameterRequired: "Obrigatório",
    parameterOptions: "Opções",
    parameterHelp: "Texto de apoio",
    parameterHelpPlaceholder: "Uma linha abaixo do campo, explicando o que se responde.",
    typeEnum: "Lista de opções",
    typeText: "Texto livre",
    typeNumber: "Número",
    typeBoolean: "Sim ou não",
    preferEnum:
      "Texto livre entra no que o agente lê. Quando as respostas possíveis são conhecidas, uma lista de opções fecha essa borda.",
    addParameter: "Adicionar parâmetro",
    confirm: "Publicar",
    doneTitle: "Skill publicada",
    doneDescription: "{{skill}} está no catálogo.",
    failed: "Não foi possível publicar a skill.",
  },
  admin: {
    searchPlaceholder: "Buscar por nome, assunto, provedor ou etiqueta...",
    columnName: "Skill",
    columnScope: "Instala em",
    columnVersion: "Versão",
    columnInstalls: "Instalações",
    saved: "Salvo",
    saveFailed: "Não foi possível salvar a alteração.",
    dangerZone: "Zona de risco",
    inactivate: "Inativar",
    inactivateHint_one:
      "A skill sai do catálogo e deixa de ser servida. A {{count}} instalação existente mantém o registro dela e encontra a skill recusada na próxima execução, com o motivo abaixo. Nada é excluído.",
    inactivateHint_other:
      "A skill sai do catálogo e deixa de ser servida. As {{count}} instalações existentes mantêm os registros delas e encontram a skill recusada na próxima execução, com o motivo abaixo. Nada é excluído.",
    inactiveNow: "Esta skill está inativa. Motivo: {{reason}}",
    reactivate: "Devolver ao catálogo",
    reasonPlaceholder: "Por que ela está saindo? Este texto chega a quem a instalou.",
    reasonRequired: "O motivo é obrigatório — skill que some sem explicação deixa a pessoa adivinhando.",
    details: "Detalhes",
    columnActions: "Ações",
    makeCore: "Tornar core",
    removeCore: "Remover core",
    columnStatus: "Situação",
    ofVersions_one: "de {{count}}",
    ofVersions_other: "de {{count}}",
    notLive: "Fora do ar",
    compare: "Comparar versões",
    showVersion: "Mostrando a versão",
    needTwoVersions: "Comparar exige ao menos duas versões publicadas.",
    comparingFile: "Comparando {{path}}",
    core: "Core",
    corePromoted: "Skill promovida a core",
    coreDemoted: "Skill deixou de ser core",
    coreFailed: "Não foi possível alterar a marcação de core.",
    corePromptTitle: "Tornar esta skill core?",
    corePromptBody:
      "{{skill}} passará a ser servida a TODA organização imediatamente, sem ser instalada — e nenhuma organização poderá recusá-la. Skill core também não tem parâmetro respondido nem ferramenta escolhida, porque não há instalação onde guardá-los.",
    corePromptConfirm: "Tornar core",
    coreHint:
      "Faz parte da ferramenta. É servida a toda organização sem ser instalada, e não pode ser instalada — a forma de tirá-la do ar é bloquear.",
    everyone: "Todas",
    everyoneHint:
      "Skill core não tem linha de instalação: ela alcança toda organização por definição, então não há o que contar.",
    statusActive: "Publicada",
    statusInactive: "Inativa",
    noReason: "Sem motivo registrado.",
    empty: "Nenhuma skill publicada no catálogo da plataforma ainda.",
    emptySearch: "Nenhuma skill corresponde a esta busca.",
  },
  scope: {
    organization: "Organização",
    product: "Workspace",
    user: "Só para mim",
    hint: {
      organization:
        "Vale para todos os workspaces da organização. Todo agente conectado carrega o nome e a descrição dela no início da sessão.",
      product: "Vale para quem trabalha neste workspace.",
      user: "Vale só para você. Ninguém mais recebe esta skill.",
    },
    installedIn: {
      organization: "Instalada na organização",
      product: "Instalada no workspace",
      user: "Instalada só para você",
    },
    manageWhereInstalled:
      "Para alterá-la ou removê-la, vá ao nível em que ela foi instalada.",
    alreadyInstalledIn: {
      organization:
        "Esta skill já está instalada na organização, e alcança todos os workspaces. A mesma skill instalada duas vezes chegaria ao agente em duplicidade.",
      product:
        "Esta skill já está instalada em um workspace desta organização. Instalá-la também na organização a faria chegar ao agente em duplicidade.",
      user:
        "Você já tem esta skill em Minhas Skills. Instalá-la aqui a faria chegar ao agente em duplicidade.",
    },
  },
  update: {
    dialog: {
      title: "Trocar a versão",
      rollbackTitle: "Voltar para uma versão anterior",
      description: "Trocar de versão troca o procedimento. Veja o que muda antes de confirmar.",
      rollbackDescription:
        "Voltar desfaz o que estas versões trouxeram. Veja o que deixa de valer antes de confirmar.",
      upToDate: "Esta instalação já está na versão mais recente.",
      noNotes: "Sem notas nesta versão.",
      parametersAdded: "Parâmetros novos",
      parametersRemoved: "Parâmetros removidos",
      parametersRemovedHint: "As respostas gravadas para estes parâmetros serão descartadas.",
      requirements: "Ferramentas exigidas",
      requiredWarning:
        "A versão nova pede um parâmetro obrigatório que ainda não foi respondido. Depois de atualizar, preencha-o na aba de Parâmetros.",
      undone: "O que deixa de valer",
      confirm: "Atualizar agora",
      confirmRollback: "Voltar agora",
    },
    action: "Nova versão disponível",
    badge: "Atualizar",
    rollback: "Voltar para esta",
    rollbackHint: "Devolve esta instalação à versão {{version}}. Nada é republicado — muda só o que é servido aqui.",
    hint: "Você está na versão {{version}}. A troca de versão nunca acontece sozinha: a skill é um procedimento que o time já validou, e trocá-lo por baixo mudaria o resultado sem ninguém ter decidido.",
  },
  updated: {
    title: "Skill atualizada",
    description: "{{skill}} passou para a versão {{version}}.",
  },
  updateFailed: "Não foi possível atualizar a skill.",
  mine: {
    title: "Minhas skills",
    description:
      "Procedimentos que valem só para você. Ninguém mais os recebe, e você não precisa de aprovação para instalá-los.",
    empty: "Você ainda não tem nenhuma skill sua.",
    emptyCatalog: "Nenhuma skill do catálogo aceita o nível individual por enquanto.",
    available: "Disponíveis para instalar",
    loadFailed: "Não foi possível carregar suas skills.",
  },
  configure: "Configurar",
  options: "Opções",
  addJob: "Executar automaticamente",
  selectOrganization: "Selecione uma organização para ver as skills.",
  parameters: {
    hint: "A skill precisa destas respostas para rodar do jeito daqui. Elas ficam guardadas nesta instalação.",
    required: "obrigatório",
    yes: "Sim",
    no: "Não",
    none: "Esta skill não pede nenhum parâmetro.",
    title: "Parâmetros",
    save: "Salvar parâmetros",
    saved: "Parâmetros atualizados",
  },
  card: {
    more: "ver mais",
  },
  filter: {
    searchPlaceholder: "Buscar por nome, assunto ou etiqueta",
    clearSearch: "Limpar a busca",
    all: "Todas",
    store: "Loja",
    installed: "Instaladas",
    facets: "Etiquetas",
    clear: "Limpar",
    noResults: "Nenhuma skill corresponde ao filtro.",
  },
  settings: {
    tabs: {
      overview: "Visão geral",
      license: "Licença",
      content: "Conteúdo",
      integrations: "Ferramentas",
      versions: "Versões",
      history: "Histórico",
      security: "Segurança",
    },
    versions: {
      empty: "Nenhuma versão publicada.",
      installed: "Instalada",
      latest: "Mais recente",
    },
    history: {
      empty: "Nada registrado ainda.",
      installed: "Instalada",
      uninstalled: "Desinstalada",
      hint: "O registro cobre o que pessoas fizeram com esta skill neste nível. O Prodgy não executa a skill — quem a executa é o agente.",
    },
    back: "Voltar",
    notInstalled: "Esta skill não está instalada aqui.",
    version: {
      title: "Versão",
      current: "Esta é a versão mais recente do catálogo.",
      outdated:
        "Há a versão {{version}} no catálogo. A troca não acontece sozinha — a skill é um procedimento que o time validou.",
    },
    integrations: {
      title: "Ferramentas escolhidas",
    },
    tools: {
      title_one: "{{count}} ferramenta disponível",
      title_other: "{{count}} ferramentas disponíveis",
      none: "Esta ferramenta não publica operações.",
      hint: "Estas são as operações que a skill pode acionar. Foram registradas no momento da instalação — ferramenta que ganhe uma operação nova depois não altera o que já está instalado.",
    },
    remove: {
      title: "Remover a skill",
      hint: "A skill deixa de ser servida aqui na hora. O registro é preservado, o histórico de uso continua consultável, e ela pode ser instalada de novo depois.",
    },
    blocked: {
      title: "Skills bloqueadas",
      description:
        "Skill bloqueada deixa de ser servida em toda a organização — em todos os workspaces e também no espaço pessoal de quem já a tinha instalado.",
      choose: "Escolha uma skill para bloquear",
      nothingToBlock: "Todas as skills do catálogo já estão bloqueadas.",
      empty: "Nenhuma skill bloqueada.",
      loadFailed: "Não foi possível carregar as skills bloqueadas.",
    },
    repository: {
      title: "Repositório de versionamento",
      description:
        "Conectar um repositório Git próprio para espelhar as versões das skills e receber contribuições por pull request.",
      soon: "Em breve",
    },
  },
  installFailed: "Não foi possível instalar a skill.",
  uninstallFailed: "Não foi possível desinstalar a skill.",
};

export default skills;
